import { Header, Segment, Grid, Icon } from 'semantic-ui-react';
import React from 'react';
import { Link} from 'react-router-dom';

const PageHeader = ({inst}) => {
  var header = inst ? inst : "Homecare"
    return (
      <Segment
      basic
      style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
      fluid="true"
    >
      {/* <Grid >
      <Grid.Column width='3'/>
        <Grid.Column width='16'> */}
          <Header
            as={Link}
            to="/"
            inverted 
            content={header} 
            size="large" 
            color="black"
            style={{cursor: "default"}}
          />
        {/* </Grid.Column> */}
        
        
      {/* </Grid> */}
    </Segment>
    );
  };

  export default PageHeader;